var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appBody bg-white min-height"},[_c('little-header'),_c('van-empty',{staticClass:"custom-image",attrs:{"image":"/static/img/pro/403.png","description":"暂无访问权限"}}),_c('little-footer',{staticClass:"fixed-bottom max-w-640 m-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }